'use client';

export function NewOrganizationAlertModal() {
  return null;
}
